<template>
    <div class="row">
        <div class="col-md-6">
            <div class="form-group mb-2">
                <small class="input-title">Tracking</small>
                <div class="input-group input-group-sm">
                    <div class="input-group-prepend">
                        <span class="input-group-text">
                            #
                        </span>
                    </div>
                    <input type="text" class="form-control form-control-sm" readonly v-model="data.tracking" :class="errors.tracking ? 'is-invalid' : ''">
                    <small class="invalid-feedback" v-for="(error, index) in errors.tracking" :key="index">{{ error }}</small>
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group mb-2">
                <small class="input-title">Transportista</small>
                <v-select v-model="data.carrier_id" :items="carriers" item-text="name" item-value="id"
                    hide-details no-data class="form-control form-control-sm"
                    :class="errors.carrier_id ? 'is-invalid' : ''">
                </v-select>                
                <small class="invalid-feedback" v-for="(error, index) in errors.carrier_id" :key="index">{{ error }}</small>
            </div>
        </div>
        <div class="col-md-12">
            <div class="form-group mb-2">
                <small class="input-title">Descripción</small>
                <v-combobox
                    v-model="data.description"
                    chips
                    hide-details
                    multiple
                    clearable
                    :delimiters="[',']"
                    :search-input.sync="search_description"
                    @update:search-input="MEOW_INPUT"
                    class="form-control form-control-sm textarea"
                    :class="errors.description ? 'is-invalid' : ''">
                        <template v-slot:selection="{ attrs, item, select, selected }">
                            <v-chip
                                small
                                v-bind="attrs"
                                close
                                @click:close="REMOVE(item)"
                                :input-value="selected">
                                <div class="nowrap">{{ item }}</div>
                            </v-chip>
                        </template>
                </v-combobox>
                <small class="invalid-feedback" v-for="(error, index) in errors.description"
                    :key="index">{{ error }}</small>
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group mb-2">
                <small class="input-title">Cliente</small>
                <search-user v-model="data.user" @set_value="e => data.user_id = e" :childclass="errors.user_id ? 'is-invalid' : ''"/>
                <small class="invalid-feedback" v-for="(error, index) in errors.user_id" :key="index">{{
                    error
                }}</small>
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group mb-2">
                <small class="input-title">Remitente (tienda)</small>
                <search-shipper v-model="data.shipper" :childclass="errors.shipper ? 'is-invalid' : ''"/>
                <small class="invalid-feedback" v-for="(error, index) in errors.shipper"
                    :key="index">{{ error }}</small>
            </div>
        </div>
        <div class="col-md-2">
            <div class="form-group mb-2">
                <small class="input-title">Largo</small>
                <div class="input-group input-group-sm">
                    <input type="text" class="form-control form-control-sm" @keypress="DOUBLE" v-model="data.lengthy" :class="errors.lengthy ? 'is-invalid' : ''">
                    <div class="input-group-append">
                        <span class="input-group-text">
                            cm
                        </span>
                    </div>
                    <small class="invalid-feedback" v-for="(error, index) in errors.lengthy" :key="index">{{ error }}</small>
                </div>
            </div>
        </div>
        <div class="col-md-2">
            <div class="form-group mb-2">
                <small class="input-title">Ancho</small>
                <div class="input-group input-group-sm">
                    <input type="text" class="form-control form-control-sm" @keypress="DOUBLE" v-model="data.width" :class="errors.width ? 'is-invalid' : ''">
                    <div class="input-group-append">
                        <span class="input-group-text">
                            cm
                        </span>
                    </div>
                    <small class="invalid-feedback" v-for="(error, index) in errors.width" :key="index">{{ error }}</small>
                </div>
            </div>
        </div>
        <div class="col-md-2">
            <div class="form-group mb-2">
                <small class="input-title">Alto</small>
                <div class="input-group input-group-sm">
                    <input type="text" class="form-control form-control-sm" @keypress="DOUBLE" v-model="data.tall" :class="errors.tall ? 'is-invalid' : ''">
                    <div class="input-group-append">
                        <span class="input-group-text">
                            cm
                        </span>
                    </div>
                    <small class="invalid-feedback" v-for="(error, index) in errors.tall" :key="index">{{ error }}</small>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="form-group mb-2">
                <small class="input-title">Peso Volumétrico</small>
                <div class="input-group input-group-sm">
                    <input type="text" class="form-control form-control-sm" @keypress="DOUBLE" v-model="data.volumetric_weight" :class="errors.volumetric_weight ? 'is-invalid' : ''">
                    <div class="input-group-append">
                        <span class="input-group-text">
                            lbs
                        </span>
                    </div>
                    <small class="invalid-feedback" v-for="(error, index) in errors.volumetric_weight" :key="index">{{ error }}</small>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="form-group mb-2">
                <small class="input-title">Peso</small>
                <div class="input-group input-group-sm">
                    <input type="text" class="form-control form-control-sm" @keypress="DOUBLE" v-model="data.weight" :class="errors.weight ? 'is-invalid' : ''">
                    <div class="input-group-append">
                        <span class="input-group-text">
                            lbs
                        </span>
                    </div>
                    <small class="invalid-feedback" v-for="(error, index) in errors.weight" :key="index">{{ error }}</small>
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group mb-2">
                <small class="input-title">Piezas</small>
                <input type="text" class="form-control form-control-sm" @keypress="DOUBLE" v-model="data.pieces" :class="errors.pieces ? 'is-invalid' : ''">
                <small class="invalid-feedback" v-for="(error, index) in errors.pieces" :key="index">{{ error }}</small>
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group mb-2">
                <small class="input-title">Embalaje</small>
                <v-select v-model="data.packing_id"
                    :items="packings"
                    item-text="name"
                    item-value="id"
                    hide-details
                    class="form-control form-control-sm"
                    :class="errors.packing_id ? 'is-invalid' : ''">
                </v-select>
                <small class="invalid-feedback" v-for="(error, index) in errors.packing_id" :key="index">{{ error }}</small>
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group mb-2">
                <small class="input-title">Acción Requerida</small>
                <v-select v-model="data.action"
                    :items="actions"
                    hide-details
                    class="form-control form-control-sm"
                    :class="errors.action ? 'is-invalid' : ''">
                </v-select>
                <small class="invalid-feedback" v-for="(error, index) in errors.action" :key="index">{{ error }}</small>
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group mb-2">
                <small class="input-title">Fotografias del Paquete</small>
                <v-file-input
                    hide-details
                    truncate-length="50"
                    v-model="data.file"
                    :class="errors.file ? 'is-invalid border-danger' : ''"
                    class="form-control form-control-sm cursor-pointer"
                    :placeholder="'Escoge una imagen'">
                </v-file-input>
                <small class="invalid-feedback" v-for="(error, index) in errors.file" :key="index">{{ error }}</small>
            </div>
        </div>
        <div class="col-12">
            <div class="form-group mb-2 d-flex align-items-center">
                <small class="input-title" style="width: 140px;">Archivos Adjuntos: </small>
                <div class="ml-2" style="width: calc(100% - 140px);">
                    <div class="py-3"></div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-1 col-md-2 col-sm-3 col-4" v-for="(item, index) in data.files">
                    <img :src="`${item.path}`" class="img-fluid" v-if="item.type != 'pdf'">
                    <img :src="pdf" class="img-fluid" v-else>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import pdf from '@/assets/img/pdf.png'
export default {
    props: ['data', 'errors'],
    data(){
        return{
            actions: [
                { value: 0, text: 'No' },
                { value: 1, text: 'Si' }
            ],
            carriers: [],
            users: [],
            shippers: [],
            packings: [],
            loading: '',
            search_two: '',
            enter_two: 1,
            count: 0,
            search_description: '',
            pdf
        }            
    },
    created(){
        let vue = this
        vue.CARRIERS()
        vue.PACKINGS()
    },
    methods: {
        CARRIERS: function () {
            let vue = this
            axios({ url: '/all/carriers', method: 'GET' })
                .then((resp) => {
                    vue.carriers = resp.data
                })
        },
        PACKINGS: function () {
            let vue = this
            axios({ url: '/all/packings', method: 'GET' })
                .then((resp) => {
                    vue.packings = resp.data
                })
        },
        USERS: function () {
            let vue = this
            axios({
                url: '/search/users?query=' + vue.search_one,
                method: 'GET'
            })
                .then((resp) => {
                    vue.users = resp.data
                })
                .catch((err) => {
                    if (err.response.status === 402) {
                       let message = err.response ? err.response.data.message : err.message
                        vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    } else {
                        vue.$swal({ toast: true, icon: 'error', title: err.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    }
                })
                .finally((resp) => {
                    vue.loading = ''
                    vue.enter_one = 1
                })
        },
        SHIPPERS: function () {
            let vue = this
            axios({
                url: '/search/shipper?query=' + vue.search_two,
                method: 'GET'
            })
                .then((resp) => {
                    vue.shippers = resp.data
                })
                .catch((err) => {
                    if (err.response.status === 402) {
                       let message = err.response ? err.response.data.message : err.message
                        vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    } else {
                        vue.$swal({ toast: true, icon: 'error', title: err.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    }
                })
                .finally((resp) => {
                    vue.loading = 'shippers'
                    vue.enter_two = 1
                    if (vue.shippers.length == 0) {
                        vue.APPEND_SHIPPER()
                    }
                })
        },
        APPEND_SHIPPER: function () {
            let vue = this
            vue.shippers.push(vue.search_two)
        },
        CHANGE_TWO: function () {
            let vue = this
            vue.shippers = []
            vue.enter_two = 0
        },
        REMOVE: function(item) {
            if(this.data.description){
                this.data.description.splice(this.data.description.indexOf(item), 1)
            }
        },
        MEOW_INPUT(e1) {
            if (this.search_description && this.search_description.split(",").length > 1) {
                this.data.description = this.data.description.concat(
                    this.search_description.split(",").filter((term) => !this.data.description.includes(term))
                );
                this.search_description = "";
            }
        },
    },
    watch: {
        search_two: {
            handler(value) {
                let vue = this
                setTimeout(() => {
                    if (value != vue.search_two) {
                        vue.enter_two = 1
                    }
                }, 500)
                if (value) {
                    if (vue.enter_two == 1) {
                        vue.loading_shippers = true
                        setTimeout(() => {
                            if (vue.search_two.length == value.length) {
                                vue.SHIPPERS()
                            }
                        }, 500)
                    }
                } else {
                    vue.shippers = []
                }
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/packages/forms/Package.vue